import { CSRF_COOKIE } from '../constants/network';

// The session JWT (auth_token) is httpOnly and never visible here. Only the
// double-submit csrf_token cookie is readable, by design of the Core contract.
export function readCsrfCookie(cookieSource = typeof document === 'undefined' ? '' : document.cookie) {
    const prefix = `${CSRF_COOKIE}=`;
    for (const part of String(cookieSource).split(';')) {
        const trimmed = part.trim();
        if (trimmed.startsWith(prefix)) return decodeURIComponent(trimmed.slice(prefix.length));
    }
    return null;
}
